import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { TypeOfSetting } from 'mbs-ui-shared@models/rmm-custom-notification-model';
import { AlertCustomisationHandler, RMM_ALERT_CUSTOMISATION_TOKEN } from 'mbs-ui-shared@utils/rmmAlertCustomisationHandler';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfigurationService } from './configuration.service';
import { RmmService } from './rmm.service';

@Injectable({ providedIn: 'root' })
export class RmmCustomAlertingService {
  private mbsStageKey: string;
  private defaultParams: HttpParams = null;
  private alertingApi;
  private productAndType = 'rmm/alertsettings';
  private baseApiURL: string;

  constructor(
    @Inject(ConfigurationService) private config: ConfigurationService,
    @Inject(RMM_ALERT_CUSTOMISATION_TOKEN) public rmmAlertCustomisationHandler: AlertCustomisationHandler,
    private rmmService: RmmService,
    private http: HttpClient
  ) {
    const rmmBaseUrl = this.config.get('rmmCustomSettings');
    this.baseApiURL = this.config.get('rmmBaseHref');

    // settings-rmm16
    this.alertingApi = `${rmmBaseUrl}/api/custom/provider`;

    this.mbsStageKey = this.config.get('mbsStageKey');
    this.defaultParams = new HttpParams({
      fromObject: {
        mbsStageKey: this.mbsStageKey
      }
    });
  }

  getSettings(settingsFor: TypeOfSetting, uniqueId = null): Observable<any> {
    return this.http.get(this.alertingApi + `/${settingsFor}/${this.productAndType}` + (uniqueId ? `/${uniqueId}` : ''), {
      params: this.defaultParams
    });
  }

  saveSettings(settingsFor: TypeOfSetting, settings: any, uniqueId = null): Observable<unknown> {
    return this.http.post(
      this.alertingApi + `/${settingsFor}/${this.productAndType}` + (uniqueId ? `/${uniqueId}` : ''),
      JSON.stringify({ ...settings }),
      { params: this.defaultParams }
    );
  }

  deleteSettings(settingsFor: TypeOfSetting, uniqueId = null) {
    return this.http.delete(this.alertingApi + `/${settingsFor}/${this.productAndType}` + (uniqueId ? `/${uniqueId}` : ''), {
      params: this.defaultParams
    });
  }

  getActualComputerSettingsByHid(hid: string) {
    return this.http.get(this.alertingApi + `/${TypeOfSetting.Computer}/${this.productAndType}/${hid}/find`, {
      params: this.defaultParams
    });
  }

  private parseData = (response) => {
    if (!response) {
      return {};
    }
    if (Array.isArray(response)) {
      return response;
    }

    return response.data || JSON.parse(response.result).data;
  };

  public sendClearSettingCacheRequest() {
    return this.http.post(`${this.baseApiURL}/api/Owners/events/datachanged`, null);
  }

  public sendAgentSettingsCommand = <TData>(typeOfSetting: TypeOfSetting, id: string = null, body?): Observable<TData> => {
    const partOfURL = typeOfSetting === TypeOfSetting.Computer ? id : 'all';
    const url = `${this.rmmService.statBaseUrl}/rm/${partOfURL}/commands/updatesettings`;

    let params: HttpParams = new HttpParams({
      fromObject: {
        mbsStageKey: this.mbsStageKey,
        type: 'alertsettings'
      }
    });

    if (typeOfSetting === TypeOfSetting.Company) params = params.append('companyid', id);

    return this.http
      .post(url, null, {
        params,
        headers: { 'Content-Type': 'application/json' }
      })
      .pipe(map(this.parseData));
  };
}
